import React, { FC, useEffect, useState } from 'react';
import { StorageHelper } from '../../../utils/StorageHelper';
import { useAppStore } from '../../../store/AppContext';
import TarjetaService from '../../../services/TarjetaService';

interface Props {
  hittype: string;
  event_category: string;
  event_action: string;
  event_label: string;
}

const WaMenuMastercardLink: FC<Props> = (props) => {
  const { event_action, event_category, event_label, hittype } = props;
  const dataApp = useAppStore();
  const { access, lang } = dataApp;
  const APP_BASE_URL = document.location.hostname.includes('eroski.es')
    ? process.env.REACT_APP_BASE_URL
    : process.env.REACT_APP_BASE_URL_CAPRABO;

  const [url, setUrl] = useState('');

  const solicitarTarjetaPago = async () => {
    const token = await TarjetaService.solicitarToken();
    let dataToken = token.data;
    if (dataToken == null || dataToken === '') {
      dataToken = null;
    }
    setUrl(dataToken);
    return dataToken;
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  const handlerClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    solicitarTarjetaPago().then((resp) => {
      StorageHelper.deleteUserFromSessionAndRedirect(
        access.solicitarTarjeta,
        lang,
        APP_BASE_URL,
        e,
        resp,
      );
    });
  };

  return (
    <>
      <div className="icon-link-block">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          data-wa-hittype={hittype}
          data-wa-event-category={event_category}
          data-wa-event-action={event_action}
          data-wa-event-label={event_label}
          href=""
          onClick={(e) => handlerClick(e)}
          className="icon-link icon-link__oro"
        >
          <img src={access.solicitarTarjeta?.urlImagen} alt="" />
          <span>{access.solicitarTarjeta?.descripcion}</span>
        </a>
      </div>
    </>
  );
};
export default WaMenuMastercardLink;
